// src/stores/car.js
import { defineStore } from "pinia";
import { httpRequest } from "@/services/api";
import { showAlert } from "@/composables/useAlert";

export const useCarStore = defineStore("car", {
  state: () => ({
    carDetails: [],
    myCars: [],
    carId: null,
    isLoading: false,
  }),

  actions: {
    async getCarDetails(carId) {
      this.isLoading = true;
      try {
        const res = await httpRequest(`/cars/${carId}`, { method: "GET" });
        this.carDetails = res.data || [];
      } catch (error) {
        showAlert(
          error.response?.data?.message || "حدث خطأ أثناء جلب البيانات",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },
    async addCar(details) {
      this.isLoading = true;
      try {
        const res = await httpRequest(`/cars/store`, {
          method: "POST",
          data: details,
          headers: { "Content-Type": "multipart/form-data" },
        });
        this.carId = res.data.id || null;
        return this.carId;
      } catch (error) {
        showAlert(
          error.response?.data?.message || "حدث خطأ أثناء جلب البيانات",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },
    async getMyCars() {
      this.isLoading = true;
      try {
        const res = await httpRequest(`/user/my-cars?pageSize=-1`, { method: "GET" });
        this.myCars = res.data || [];
      } catch (error) {
        showAlert(
          error.response?.data?.message || "حدث خطأ أثناء جلب البيانات",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },
  },
});
